import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
function Footer() {

    return (
        <>
            <footer>
                <div className="container">
                    <div className="footer-content">
                        <div className="row">
                            <div className="col-lg-3 ">
                                <div className="widget widget-about">
                                    <Link to='/how-it-works' className="h1 text-white">How It Works</Link>
                                </div>
                                <Link to='/contact-us' className='btn btn-primary'>Contact Us</Link>
                            </div>
                            <div className="col-lg-3 ">
                                {/* <div className="widget widget-contact">
                                    <h3 className="widget-title">Information</h3>
                                    <ul className="cont-links">
                                        <li>
                                            <i className="la la-phone"></i>
                                            +1 212-758-8877
                                        </li>
                                        <li>
                                            <i className="la la-map-marker"></i>
                                            1 E 57th St, New York
                                        </li>
                                        <li>
                                            <i className="la la-clock-o"></i>
                                            10AM - 9PM
                                        </li>
                                    </ul>
                                </div> */}
                            </div>
                            <div className="col-md-6">
                                <div className="text-white">
                                    <h1 className="text-white">Other Services</h1>
                                    <div className='row'>
                                        <div className='col-md-6'>
                                            <ul>

                                                <li><Link className="text-white font-weight-bold" to="/ad-landing">Advertise with us </Link></li>
                                                <li>Insurance Renters</li>
                                                <li>Insurance Owners</li>
                                            </ul>

                                        </div>
                                        <div className='col-md-6'>
                                            <ul className="social-links">
                                                <li>State Contracts</li>
                                                <li>
                                                    <Link  className="text-white font-weight-bold" to="https://www.rabbitsign.com/" target="_blank">RabbitSign.com </Link></li>
                                                <li>Credit Report</li>
                                            </ul>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </footer>
                </>
    );
};

export default Footer;
